import { borderWidths, borderStyles } from '../borders.js';
import { transitions } from '../transition.js';
import { colors } from '../colors.js';
import { radii } from '../radius.js';
import { sizes } from '../sizing.js';
import { space } from '../spacing.js';
export const modalBox = {
    backgroundColor: colors.backgrounds.onGray,
    borderRadius: radii.x1_5,
    width: sizes.x120,
    boxShadow: {
        color: 'secondary',
        style: 'broad',
        alpha: 'x6',
    },
    boxBody: {
        padding: space.x4,
    },
    footer: {
        desktopPaddingTop: space.x6,
        padding: space.x4,
    },
    headerLabel: {
        padding: space.x4,
        paddingRight: space.x0,
    },
    closeButton: {
        margin: space.x4,
        mobileHeight: sizes.x12,
        mobileRight: space.x1,
        mobileTop: space.x1,
        mobileMargin: space.x0,
        mobilePadding: space.x4,
    },
    border: {
        style: borderStyles.solid,
        width: borderWidths.sm,
        color: colors.borders.default,
        transparentColor: colors.transparent,
    },
    transition: {
        timingFunction: transitions.easing['ease-out'],
        property: transitions.property.common,
        duration: transitions.duration.fast,
    },
};
//# sourceMappingURL=modal-box.js.map